import { Checkbox, Tooltip } from "antd";
import { AlertCircle } from "lucide-react";
import { Button, Card } from "react-bootstrap";

interface IFeaturesCommitmentInfo {
  isChecked: boolean;
  handleIsCheck: (isCheck: boolean) => void;
  handleCancel: () => void;
  handleContinue: () => void;
}

const CommitmentInfo = (props: IFeaturesCommitmentInfo) => {
  const { isChecked, handleIsCheck, handleCancel, handleContinue } = props;
  return (
    <>
      <Card className="w-full max-w-3xl mx-auto">
        <Card.Header>
          <div className="d-flex items-start gap-3 justify-content-center">
            <div className="align-items-center d-flex">
              <AlertCircle className="text-info-emphasis text-amber-500 mt-0.5 flex-shrink-0" />
            </div>
            <h2 className="text-lg font-semibold text-info-emphasis">
              Certification préalable à l’envoi de communications électroniques
            </h2>
          </div>
        </Card.Header>
        <Card.Body className="pt-6">
          <div className="space-y-4 text-sm">
            <p>
              En cochant la présente case et préalablement à tout envoi de courriels, newsletters ou communications électroniques via la plateforme ALO (Annonce Légale Officielle), le titulaire du compte certifie et reconnaît expressément ce qui suit :
            </p>
            <h4>
              1. Responsabilité exclusive du contenu
            </h4>
            <p>
              Le titulaire du compte reconnaît être <strong>seul responsable</strong> du contenu des messages envoyés via la plateforme ALO, tant sur le plan rédactionnel que visuel, incluant notamment les textes, images, logos, pièces jointes, liens hypertextes ou tout autre élément intégré au message.
            </p>

            <h4>
              1. Responsabilité exclusive du contenu
            </h4>
            <p>
              Le titulaire du compte reconnaît être <strong>seul responsable</strong> du contenu des messages envoyés via la plateforme ALO, tant sur le plan rédactionnel que visuel, incluant notamment les textes, images, logos, pièces jointes, liens hypertextes ou tout autre élément intégré au message.
            </p>
            <p>
              La société exploitant la plateforme ALO (Annonce Légale Officielle), ses dirigeants, salariés, prestataires ou partenaires ne sauraient en aucun cas être tenus responsables du contenu diffusé par l’utilisateur.
            </p>

            <h4>
              2. Absence totale de responsabilité de ALO
            </h4>
            <p>
              ALO (Annonce Légale Officielle) intervient exclusivement en qualité de prestataire technique de mise à disposition d’un outil d’envoi.
            </p>
            <p>
              À ce titre, ALO n’exerce aucun contrôle préalable, validation, modification ou surveillance des contenus envoyés et ne peut être tenue responsable, à quelque titre que ce soit, des conséquences juridiques, financières ou commerciales liées aux envois effectués par l’utilisateur.
            </p>

            <h4>
              3. Licéité des bases de données utilisées
            </h4>
            <p>
              Le titulaire du compte certifie que :
              <ul>
                <li style={{ fontSize: "1em" }}><strong>- les adresses électroniques utilisées lui appartiennent ou sont utilisées de manière licite ;</strong></li>
                <li style={{ fontSize: "1em" }}><strong>- aucun fichier de contacts n’a été acheté, loué, cédé ou obtenu illicitement ;</strong></li>
                <li style={{ fontSize: "1em" }}><strong>- les destinataires ont été collectés conformément à la réglementation en vigueur.</strong></li>
              </ul>
            </p>

            <h4>
              4. Respect de la réglementation applicable (RGPD – CNIL – Code des communications électroniques)
            </h4>
            <p>
              Le titulaire du compte s’engage à respecter strictement l’ensemble des obligations légales et réglementaires applicables, et notamment :
              <ul>
                <li style={{ fontSize: "1em" }}><strong>- le Règlement Général sur la Protection des Données (RGPD) ; </strong></li>
                <li style={{ fontSize: "1em" }}><strong>- les règles relatives à la prospection électronique en B2B et en B2C, les obligations d’information, de consentement lorsque requis, et de droit d’opposition des destinataires. </strong></li>
              </ul>
            </p>

            <div className="flex items-center space-x-2 pt-2">
              <Checkbox
                id="agreement"
                checked={isChecked}
                onChange={(e) => handleIsCheck(e.target.checked)}
              />
              <label
                htmlFor="agreement"
                className="ms-2 cursor-pointer"
                style={{fontSize: "1.1em", fontWeight: 'bold'}}
              >
                J'ai lu et j'accepte les conditions ci-dessus
              </label>
            </div>

            <div className="d-flex justify-content-end gap-3 pt-4">
              <Button variant="outline" onClick={handleCancel}>
                Annuler
              </Button>

              <Tooltip
                title={
                  !isChecked
                    ? "Veuillez cocher « J’ai lu et j’accepte les conditions ci-dessus » avant de poursuivre l’envoi du mail."
                    : ""
                }
                placement="top"
              >
                <span>
                  <Button
                    onClick={handleContinue}
                    disabled={!isChecked}
                  >
                    Continuer
                  </Button>
                </span>
              </Tooltip>
            </div>

          </div>
        </Card.Body>
      </Card>
    </>
  );
};

export default CommitmentInfo